import { Component, HostListener, TemplateRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Spinkit } from 'ng-http-loader';
import { UserService } from '../app/services/user.service';
import { SLAKPIApiService } from '../app/services/slakpi.service';
import { kpiInbox, kpiNotification } from '../app/models/slakpi';
import { BnNgIdleService } from 'bn-ng-idle';
import { UtilityService } from './services/utility.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { tenant, usermaster, userpermission } from './models/admin';
import { AdminApiService } from './services/admin.service';
import { slaNote, userrights } from './models/users';
import { RSAHelper } from './models/RSAHelper';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  html = `<p><span>New Services added!</span></br>Now you can switch between views if you have privileges</br></br><strong class="mt-2">Got it!</strong></p>`;
  @ViewChild('SwitchTenanttemplate', { static: false }) SwitchTenanttemplate: TemplateRef<any>;
  oneAtATime = true;
  Overallperf = true;
  Subsidiaryperf = true;
  title = 'ClientApp';
  public spinkit = Spinkit;
  public KPINotification_data: any = [];
  multiTenantList: any = [];
  user: any = {};
  login_UserID: string; // number
  currentYear?: number;
  currentHalf?: number;
  currentQuarter?: number;
  currentMonth?: number;
  division?: string = '';
  tenantUno: any;
  public loading: boolean = false;
  public filterDataCollectionCount: number = 0;
  public filterOverdueCount: number = 0;
  public filterCompletedCount: number = 0;
  public filterApprovalCount: number = 0;

  public filterYear_default: number = 0;
  public filterQuarter_default: number = 0;
  public filterSla_default: number = 0;
  public filterDivision_default: number = 0;
  public filterFrequency_default: number = 0;
  public filterBy_default: number = 0;

  isAdmin: boolean = false;
  nitifyCount: number = 0;
  profilePicture: string = '';
  public desingation: string = '';
  public displayname: string = '';
  public role: string = '';
  public dataTarget_notify = 'dropdown2';
  public overallText: string = '';

  public IsShow_SLA: boolean = false;
  public IsShow_SLAKPIs: boolean = false;
  public IsShow_TrackingDashboard: boolean = false;
  public IsShow_Interaction: boolean = false;
  public IsShow_SLAInteraction: boolean = false;
  public IsShow_KPIInteraction: boolean = false;
  public IsShow_SLAKPIMapping: boolean = false;
  public IsShow_AdminKPI: boolean = false;
  public IsShow_SLAKPIDatabase: boolean = false;
  public IsShow_KPITarget: boolean = false;
  public IsShow_KPIBand: boolean = false;
  public IsShow_SLAPerformance: boolean = false;
  public IsShow_SLAKPIPerformance: boolean = false;
  public IsShow_SLAIssueList: boolean = false;
  public IsShow_KPIReleaseReset: boolean = false;
  public IsShow_SLAIssueDashboard: boolean = false;
  public IsShow_ActionPlan: boolean = false;
  //BenchMark
  public IsShow_BMMasters: boolean = false;
  public IsShow_BMMetadata: boolean = false;
  public IsShow_BMKPITarget: boolean = false;
  public IsShow_BMKPIDataAcquisition: boolean = false;
  public IsShow_BMKPIInbox: boolean = false;
  public IsShow_BMTrackingSheet: boolean = false;
  public IsShow_BMKPIPosition: boolean = false;
  public IsShow_IncomingBMRequest: boolean = false;
  public IsShow_BMIncomingVisitTransaction: boolean = false;
  public IsShow_OutgoingBMRequest: boolean = false;
  public IsShow_PracticeBMSetup: boolean = false;
  public IsShow_PracticeBMApproval: boolean = false;
  public IsShow_PracticeBM: boolean = false;
  public IsShow_AnnualPerformanceBM: boolean = false;
  public IsShow_AnnualPracticeBM: boolean = false;
  public IsShow_AnnualOutingVisit: boolean = false;
  public IsShow_AwarenessSession: boolean = false;
  public IsShow_BMRequest: boolean = false;
  public IsShow_BMIncomingRequest: boolean = false;
  public IsShow_BMOutgoingRequest: boolean = false;
  public IsShow_FileManager: boolean = false;
  public IsShow_RecentUpdates: boolean = false;

  public IsShow_PerformanceBenchmarkDashboard: boolean = false;
  public IsShow_PracticeBMDashboard: boolean = false;
  public IsShow_IncomingBMdashboard: boolean = false;
  public IsShow_OutgoinginternalBMDashboard: boolean = false;
  public IsShow_AwarnessSession: boolean = false;
  public IsShow_AddincomingBMrequest: boolean = false;

  //for scroll to top
  isScrolltoTopShow: boolean;
  topPosToStartShowing = 100;
  public isDDAdmin: boolean = false;
  public isDDAdminRead: boolean = false;
  public isDDApprover: boolean = false;
  public isBMChambion: boolean = false;
  public isSLACoordinator: boolean = false;

  public isBMAdmin: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;
  public isSLAAdmin: boolean = false;
  public isUser: boolean = false;
  public isDigital: boolean = false;
  siteHeading: any = '';
  slaName: any = '';
  modalUserRef: BsModalRef;
  user_data: any;
  tenant_data: any;


  strCurrentYear: any = (new Date()).getFullYear();
  isInternalAudit: boolean = false;
  constructor(public restApiadmin: AdminApiService, private _activatedRoute: ActivatedRoute, public utilityService: UtilityService, private userService: UserService, public restApi: SLAKPIApiService, public router: Router, private bnIdle: BnNgIdleService, private modalService: BsModalService, public RASHelper: RSAHelper) {

    //once the user is idle for 15 minutes then the subscribe method will get invoked with the isTimedOut parameter's value (which is a boolean) as true. 60 -1mins
    this.bnIdle.startWatching(900).subscribe((res) => {
      if (res) {
        this.bnIdle.resetTimer();
        this.user = this.userService.getUserInfo();
        if (this.user != undefined && this.user != null) {
          this.userService.logout();
        }
      }
    })

    this.start();

    google.charts.load('current', { 'packages': ['gauge'] });
    google.charts.load('current', { 'packages': ['corechart'] });
    google.charts.load('current', { 'packages': ['table'] });
  }

  //New Site Work start
  public shouldShow = true;
  public SubmenuShow0 = true;
  public SubmenuShow1 = false;
  public SubmenuShow2 = false;
  public SubmenuShow3 = false;
  public SubmenuShow4 = false;
  public SubmenuShow5 = false;
  public SubmenuShow6 = false;
  public SubmenuShow7 = false;
  public SubmenuShow8 = false;
  public SubmenuShow9 = false;
  public SubmenuShow10 = false;
  public SubmenuShow11 = false;
  public SubmenuShow12 = false;
  animation = 'pulse';
  contentLoaded = false;
  intervalId;


  public current_continent: boolean = false;
  public current_country: boolean = false;
  public current_objective: boolean = false;
  public current_region: boolean = false;
  public current_sourcetype: boolean = false;
  public current_source: boolean = false;
  public current_utilitytype: boolean = false;
  public current_peertype: boolean = false;
  public current_peer: boolean = false;
  public current_consideration: boolean = false;
  public current_position: boolean = false;
  public current_regulator: boolean = false;
  public current_council: boolean = false;
  public current_surveyOption: boolean = false;
  public current_surveyQuestion: boolean = false;
  public current_practice: boolean = false;
  public current_priority: boolean = false;
  public current_delegates: boolean = false;

  //New Site Work end
  hideShowMenu() {
    this.shouldShow = true;
    this.SubmenuShow1 = false;
    this.SubmenuShow2 = false;
    this.SubmenuShow3 = false;
    this.SubmenuShow4 = false;
    this.SubmenuShow5 = false;
    this.SubmenuShow6 = false;
    this.SubmenuShow7 = false;
    this.SubmenuShow8 = false;
    this.SubmenuShow9 = false;
    this.SubmenuShow10 = false;
    this.SubmenuShow11 = false;
    this.SubmenuShow12 = false;
  }
  
  ngOnInit() {

    //New Site Work start
    setTimeout(() => {
      this.contentLoaded = true;
    }, 2000);

    this.intervalId = setInterval(() => {
      this.animation = this.animation === 'pulse' ? 'progress-dark' : 'pulse';
    }, 5000);

    //New Site Work end

    this.user = this.userService.getUserInfo();
    
    let switchTenant = this.userService.getSwitchTenantInfo();
    if (switchTenant != undefined && switchTenant != null) {
      if (switchTenant.id == 1) {
        localStorage.removeItem('switchTenant');

        window.location.reload();
      }
    }
    if (this.user != undefined && this.user != null) {
      this.login_UserID = this.user.id;
      this.desingation = this.user.desingation;
      this.displayname = this.user.displayname;
      this.role = this.user.role;
      this.tenantUno = this.user.tenantUno;
      this.currentYear = this.user.currentYear;
      this.currentHalf = this.user.currentHalf;
      this.currentQuarter = this.user.currentQuarter;
      this.currentMonth = this.user.currentMonth;
      this.userService.CheckLogin();

      this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'DDAdmin') ? true : false;
      this.isInternalAudit = (this.user.role == 'Internal Audit') ? true : false;

      this.division = this.user.division.toLocaleLowerCase();
      this.currentMonth = this.user.currentMonth;
      this.assignDefaultFilter();
    }

  }

  ngOnDestroy() {
    this.stop();
  }

  private start(): void {
    window.addEventListener("storage", this.storageEventListener.bind(this));
  }

  private storageEventListener(event: StorageEvent) {
    if (event.storageArea == localStorage) {
      localStorage.setItem(event.key, event.oldValue);
    }
  }

  private stop(): void {
    window.removeEventListener("storage", this.storageEventListener.bind(this));
  }

  toggleMenu() {
    setTimeout(() => {
      if (this.userService.angularGrid)
        this.userService.angularGrid.resizerService.resizeGrid();
    }, 500)

  }

  onActivate(event) {
    
    window.scroll(0, 0);
    //setTimeout(() => {

    //To Validate User Permission
    this.user = this.userService.getUserInfo();
    if (this.user != null) {
      this.Checkauthorized();
    }

    if (this.user != undefined && this.user != null && this.user != '' && this.user.id != undefined && this.user.id != null && this.user.id != '') {
      this.login_UserID = this.user.id;
      this.desingation = this.user.desingation;
      this.displayname = this.user.displayname;
      this.division = this.user.division.toLocaleLowerCase();
      this.role = this.user.role;
      this.tenantUno = this.user.tenantUno;
      this.currentYear = this.user.currentYear;
      this.currentHalf = this.user.currentHalf;
      this.currentQuarter = this.user.currentQuarter;
      this.currentMonth = this.user.currentMonth;
      this.siteHeading = this.user.siteHeading;
      this.slaName = this.user.slaname;

      this.profilePicture = this.user.profilePicture;

      this.isAdmin = (this.user != null && this.user.role == 'Administrator') ? true : false;

      this.isInternalAudit = (this.user.role == 'Internal Audit') ? true : false;

      if (this.user.role == 'SLA Coordinator') { this.isSLACoordinator = true; }

      if (this.user.role == 'SLA Admin') { this.isSLAAdmin = true; }

      if (this.user.role == 'User') { this.isUser = true; }

      if (this.user.role == 'BM Champions') { this.isBMChambion = true; }
      if (this.user.role == 'BM Team') { this.isBMTeam = true; }
      if (this.user.role == 'BM Visitor') { this.isBMVisitor = true; }
      if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }
      //TenantUser --For  Digital Dewa

      this.isDigital = (this.user.tenantDigitalUser == 'true') ? true : false;
      if (this.user.role == 'DDAdmin')
      {
        this.isDDAdmin = true;
      }
      if (this.user.role == 'DDAdminReadonly')
      {
        this.isDDAdminRead = true;
      }
      if (this.user.role == 'DDApprover') {
        this.isDDApprover = true;
      }
      if (this.isAdmin || this.isDDAdmin || this.isDDAdminRead) { this.overallText = "Performance" } else { this.overallText = ""; }

      this.userService.sidebarVisibilityChange.subscribe((value) => {
        if (this.user != undefined && this.user != null && this.user != '') {
          if (this.user.role == 'SLA Admin') { this.isSLAAdmin = true; }
          if (this.user.role == 'DDAdmin') { this.isDDAdmin = true; }
          if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }
        }

        this.filterDataCollectionCount = value[0];
        this.filterApprovalCount = value[1];
        this.filterCompletedCount = value[2];
      });

      this.loadKPIInboxCount();
      this.onClickDropDown();


      //Check if the current user is admin
      if (!this.isAdmin) {
        this.CheckReadAccess();
      }
      else {
        this.IsShow_SLA = true;
        this.IsShow_TrackingDashboard = true;
        this.IsShow_SLAKPIs = true;
        this.IsShow_Interaction = true;
        this.IsShow_SLAInteraction = true;
        this.IsShow_KPIInteraction = true;
        this.IsShow_SLAKPIMapping = true;
        this.IsShow_AdminKPI = true;
        this.IsShow_SLAKPIDatabase = true;
        this.IsShow_KPITarget = true;
        this.IsShow_KPIBand = true;
        this.IsShow_SLAPerformance = true;
        this.IsShow_SLAKPIPerformance = true;
        this.IsShow_SLAIssueList = true;
        this.IsShow_KPIReleaseReset = true;
        this.IsShow_SLAIssueDashboard = true;
        this.IsShow_ActionPlan = true;

        this.IsShow_BMMasters = true;
        this.IsShow_BMMetadata = true;
        this.IsShow_BMKPITarget = true;
        this.IsShow_BMKPIDataAcquisition = true;
        this.IsShow_BMKPIInbox = true;
        this.IsShow_BMTrackingSheet = true;
        this.IsShow_BMKPIPosition = true;
        this.IsShow_IncomingBMRequest = true;
        this.IsShow_BMIncomingVisitTransaction = true;
        this.IsShow_OutgoingBMRequest = true;
        this.IsShow_PracticeBMSetup = true;
        this.IsShow_PracticeBMApproval = true;
        this.IsShow_PracticeBM = true;
        this.IsShow_AnnualPerformanceBM = true;
        this.IsShow_AnnualPracticeBM = true;
        this.IsShow_AnnualOutingVisit = true;
        this.IsShow_BMRequest = true;
        this.IsShow_BMOutgoingRequest = true;
        this.IsShow_FileManager = true;
        this.IsShow_RecentUpdates = true;


        this.IsShow_PerformanceBenchmarkDashboard = true;
        this.IsShow_PracticeBMDashboard = true;
        this.IsShow_IncomingBMdashboard = true;
        this.IsShow_OutgoinginternalBMDashboard = true;
        this.IsShow_AwarnessSession = true;
        this.IsShow_AddincomingBMrequest = true;

      }
      var struser = localStorage.getItem('accessinfo');
      if (struser && struser != undefined && struser != '') {
        this.loadKPINotification();
      }
    }

  }

  //Validate Read Access and control all the page level permission
  CheckReadAccess() {

    //checking read access for current login user in sla masters
    let userPermissionData_SLA = this.userService.getUserRights("SLA");
    if (userPermissionData_SLA != null && userPermissionData_SLA != undefined && userPermissionData_SLA.length > 0) {
      this.IsShow_SLA = (userPermissionData_SLA[0].showPage == 1) ? true : false;
    }
    let userPermissionData_SLAKPIs = this.userService.getUserRights("SLA KPIs");
    if (userPermissionData_SLAKPIs != null && userPermissionData_SLAKPIs != undefined && userPermissionData_SLAKPIs.length > 0) {
      this.IsShow_SLAKPIs = (userPermissionData_SLAKPIs[0].showPage == 1) ? true : false;
    }
    let userPermissionData_Interaction = this.userService.getUserRights("Interaction");
    if (userPermissionData_Interaction != null && userPermissionData_Interaction != undefined && userPermissionData_Interaction.length > 0) {
      this.IsShow_Interaction = (userPermissionData_Interaction[0].showPage == 1) ? true : false;
    }
    let userPermissionData_SLAInteraction = this.userService.getUserRights("SLA Interaction");
    if (userPermissionData_SLAInteraction != null && userPermissionData_SLAInteraction != undefined && userPermissionData_SLAInteraction.length > 0) {
      this.IsShow_SLAInteraction = (userPermissionData_SLAInteraction[0].showPage == 1) ? true : false;
    }
    let userPermissionData_KPIInteraction = this.userService.getUserRights("KPI Interaction");
    if (userPermissionData_KPIInteraction != null && userPermissionData_KPIInteraction != undefined && userPermissionData_KPIInteraction.length > 0) {
      this.IsShow_KPIInteraction = (userPermissionData_KPIInteraction[0].showPage == 1) ? true : false;
    }
    let userPermissionData_SLAKPIMapping = this.userService.getUserRights("SLA & KPI Mapping");
    if (userPermissionData_SLAKPIMapping != null && userPermissionData_SLAKPIMapping != undefined && userPermissionData_SLAKPIMapping.length > 0) {
      this.IsShow_SLAKPIMapping = (userPermissionData_KPIInteraction[0].showPage == 1) ? true : false;
    }
    //checking read access for current login user in kpi-administration
    let userPermissionData_AdminKPI = this.userService.getUserRights("Admin KPI");
    if (userPermissionData_AdminKPI != null && userPermissionData_AdminKPI != undefined && userPermissionData_AdminKPI.length > 0) {
      this.IsShow_AdminKPI = (userPermissionData_AdminKPI[0].showPage == 1) ? true : false;
    }
    let userPermissionData_SLAKPIDatabase = this.userService.getUserRights("KPI Tracking Sheet");
    if (userPermissionData_SLAKPIDatabase != null && userPermissionData_SLAKPIDatabase != undefined && userPermissionData_SLAKPIDatabase.length > 0) {
      this.IsShow_SLAKPIDatabase = (userPermissionData_SLAKPIDatabase[0].showPage == 1) ? true : false;
    }
    let userPermissionData_KPITarget = this.userService.getUserRights("KPI Target");
    if (userPermissionData_KPITarget != null && userPermissionData_KPITarget != undefined && userPermissionData_KPITarget.length > 0) {
      this.IsShow_KPITarget = (userPermissionData_KPITarget[0].showPage == 1) ? true : false;
    }
    let userPermissionData_KPIBand = this.userService.getUserRights("KPI Band");
    if (userPermissionData_KPIBand != null && userPermissionData_KPIBand != undefined && userPermissionData_KPIBand.length > 0) {
      this.IsShow_KPIBand = (userPermissionData_KPIBand[0].showPage == 1) ? true : false;
    }
    //checking read access for current login user in sla-performance
    let userPermissionData_SLAPerformance_dashboard = this.userService.getUserRights("Tracking Dashboard");
    if (userPermissionData_SLAPerformance_dashboard != null && userPermissionData_SLAPerformance_dashboard != undefined && userPermissionData_SLAPerformance_dashboard.length > 0) {
      this.IsShow_TrackingDashboard = (userPermissionData_SLAPerformance_dashboard[0].showPage == 1) ? true : false;
    }
    let userPermissionData_SLAPerformance = this.userService.getUserRights("SLA Performance");
    if (userPermissionData_SLAPerformance != null && userPermissionData_SLAPerformance != undefined && userPermissionData_SLAPerformance.length > 0) {
      this.IsShow_SLAPerformance = (userPermissionData_SLAPerformance[0].showPage == 1) ? true : false;
    }
    let userPermissionData_SLAKPIPerformance = this.userService.getUserRights("SLA KPI Performance");
    if (userPermissionData_SLAKPIPerformance != null && userPermissionData_SLAKPIPerformance != undefined && userPermissionData_SLAKPIPerformance.length > 0) {
      this.IsShow_SLAKPIPerformance = (userPermissionData_SLAKPIPerformance[0].showPage == 1) ? true : false;
    }
    let userPermissionData_SLAIssueList = this.userService.getUserRights("SLA Issue List");
    if (userPermissionData_SLAIssueList != null && userPermissionData_SLAIssueList != undefined && userPermissionData_SLAIssueList.length > 0) {
      this.IsShow_SLAIssueList = (userPermissionData_SLAIssueList[0].showPage == 1) ? true : false;
    }

    
    let userPermissionData_SLAIssueDashboard = this.userService.getUserRights("SLA Issue Dashboard");
    if (userPermissionData_SLAIssueDashboard != null && userPermissionData_SLAIssueDashboard != undefined && userPermissionData_SLAIssueDashboard.length > 0) {
      this.IsShow_SLAIssueDashboard = (userPermissionData_SLAIssueDashboard[0].showPage == 1) ? true : false;
    }

    let userPermissionData_ActionPlan = this.userService.getUserRights("Action Plan");
    if (userPermissionData_ActionPlan != null && userPermissionData_ActionPlan != undefined && userPermissionData_ActionPlan.length > 0) {
      this.IsShow_ActionPlan = (userPermissionData_ActionPlan[0].showPage == 1) ? true : false;
    }

    //checking read access for current login user in entry-approval-level
    let userPermissionData_KPIReleaseReset = this.userService.getUserRights("KPI  Release / Reset");
    if (userPermissionData_KPIReleaseReset != null && userPermissionData_KPIReleaseReset != undefined && userPermissionData_KPIReleaseReset.length > 0) {
      this.IsShow_KPIReleaseReset = (userPermissionData_KPIReleaseReset[0].showPage == 1) ? true : false;
    }

    //BenchMark
    
    let userPermissionData_IsShow_BMMasters = this.userService.getUserRights("Benchmark Masters");
    if (userPermissionData_IsShow_BMMasters != null && userPermissionData_IsShow_BMMasters != undefined && userPermissionData_IsShow_BMMasters.length > 0) {
      this.IsShow_BMMasters = (userPermissionData_IsShow_BMMasters[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_BMMetadata = this.userService.getUserRights("Benchmarking Metadata");
    if (userPermissionData_IsShow_BMMetadata != null && userPermissionData_IsShow_BMMetadata != undefined && userPermissionData_IsShow_BMMetadata.length > 0) {
      this.IsShow_BMMetadata = (userPermissionData_IsShow_BMMetadata[0].showPage == 1) ? true : false;
    }
    
    let userPermissionData_IsShow_BMKPITarget = this.userService.getUserRights("Benchmarking KPI Target");
    if (userPermissionData_IsShow_BMKPITarget != null && userPermissionData_IsShow_BMKPITarget != undefined && userPermissionData_IsShow_BMKPITarget.length > 0) {
      this.IsShow_BMKPITarget = (userPermissionData_IsShow_BMKPITarget[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_BMKPIDataAcquisition = this.userService.getUserRights("KPI Data Acquisition");
    if (userPermissionData_IsShow_BMKPIDataAcquisition != null && userPermissionData_IsShow_BMKPIDataAcquisition != undefined && userPermissionData_IsShow_BMKPIDataAcquisition.length > 0) {
      this.IsShow_BMKPIDataAcquisition = (userPermissionData_IsShow_BMKPIDataAcquisition[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_BMKPIInbox = this.userService.getUserRights("KPI Inbox");
    if (userPermissionData_IsShow_BMKPIInbox != null && userPermissionData_IsShow_BMKPIInbox != undefined && userPermissionData_IsShow_BMKPIInbox.length > 0) {
      this.IsShow_BMKPIInbox = (userPermissionData_IsShow_BMKPIInbox[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_BMTrackingSheet = this.userService.getUserRights("Performance BM Tracking sheet");
    if (userPermissionData_IsShow_BMTrackingSheet != null && userPermissionData_IsShow_BMTrackingSheet != undefined && userPermissionData_IsShow_BMTrackingSheet.length > 0) {
      this.IsShow_BMTrackingSheet = (userPermissionData_IsShow_BMTrackingSheet[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_BMKPIPosition = this.userService.getUserRights("KPI Position");
    if (userPermissionData_IsShow_BMKPIPosition != null && userPermissionData_IsShow_BMKPIPosition != undefined && userPermissionData_IsShow_BMKPIPosition.length > 0) {
      this.IsShow_BMKPIPosition = (userPermissionData_IsShow_BMKPIPosition[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_IncomingBMRequest = this.userService.getUserRights("Incoming Benchmarking Request");
    if (userPermissionData_IsShow_IncomingBMRequest != null && userPermissionData_IsShow_IncomingBMRequest != undefined && userPermissionData_IsShow_IncomingBMRequest.length > 0) {
      this.IsShow_IncomingBMRequest = (userPermissionData_IsShow_IncomingBMRequest[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_BMIncomingVisitTransaction = this.userService.getUserRights("Incoming Benchmarking Request Transaction");
    if (userPermissionData_IsShow_BMIncomingVisitTransaction != null && userPermissionData_IsShow_BMIncomingVisitTransaction != undefined && userPermissionData_IsShow_BMIncomingVisitTransaction.length > 0) {
      this.IsShow_BMIncomingVisitTransaction = (userPermissionData_IsShow_BMIncomingVisitTransaction[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_OutgoingBMRequest = this.userService.getUserRights("Outgoing / Internal BM Request");
    if (userPermissionData_IsShow_OutgoingBMRequest != null && userPermissionData_IsShow_OutgoingBMRequest != undefined && userPermissionData_IsShow_OutgoingBMRequest.length > 0) {
      this.IsShow_OutgoingBMRequest = (userPermissionData_IsShow_OutgoingBMRequest[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_PracticeBMSetup = this.userService.getUserRights("Practice Benchmark Setup");
    if (userPermissionData_IsShow_PracticeBMSetup != null && userPermissionData_IsShow_PracticeBMSetup != undefined && userPermissionData_IsShow_PracticeBMSetup.length > 0) {
      this.IsShow_PracticeBMSetup = (userPermissionData_IsShow_PracticeBMSetup[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_PracticeBMApproval = this.userService.getUserRights("Practice Benchmark Approval");
    if (userPermissionData_IsShow_PracticeBMApproval != null && userPermissionData_IsShow_PracticeBMApproval != undefined && userPermissionData_IsShow_PracticeBMApproval.length > 0) {
      this.IsShow_PracticeBMApproval = (userPermissionData_IsShow_PracticeBMApproval[0].showPage == 1) ? true : false;
    }
    
    let userPermissionData_IsShow_PracticeBM = this.userService.getUserRights("Practice Benchmark Status");
    if (userPermissionData_IsShow_PracticeBM != null && userPermissionData_IsShow_PracticeBM != undefined && userPermissionData_IsShow_PracticeBM.length > 0) {
      this.IsShow_PracticeBM = (userPermissionData_IsShow_PracticeBM[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_AnnualPerformanceBM = this.userService.getUserRights("Annual Performance BM");
    if (userPermissionData_IsShow_AnnualPerformanceBM != null && userPermissionData_IsShow_AnnualPerformanceBM != undefined && userPermissionData_IsShow_AnnualPerformanceBM.length > 0) {
      this.IsShow_AnnualPerformanceBM = (userPermissionData_IsShow_AnnualPerformanceBM[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_AnnualPracticeBM = this.userService.getUserRights("Annual Practice BM");
    if (userPermissionData_IsShow_AnnualPracticeBM != null && userPermissionData_IsShow_AnnualPracticeBM != undefined && userPermissionData_IsShow_AnnualPracticeBM.length > 0) {
      this.IsShow_AnnualPracticeBM = (userPermissionData_IsShow_AnnualPracticeBM[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_AnnualOutingVisit = this.userService.getUserRights("Annual Outing Visit");
    if (userPermissionData_IsShow_AnnualOutingVisit != null && userPermissionData_IsShow_AnnualOutingVisit != undefined && userPermissionData_IsShow_AnnualOutingVisit.length > 0) {
      this.IsShow_AnnualOutingVisit = (userPermissionData_IsShow_AnnualOutingVisit[0].showPage == 1) ? true : false;
    }


    let userPermissionData_IsShow_PerformanceBenchmarkDashboard = this.userService.getUserRights("Performance Benchmark Dashboard");
    if (userPermissionData_IsShow_PerformanceBenchmarkDashboard != null && userPermissionData_IsShow_PerformanceBenchmarkDashboard != undefined && userPermissionData_IsShow_PerformanceBenchmarkDashboard.length > 0) {
      this.IsShow_PerformanceBenchmarkDashboard = (userPermissionData_IsShow_PerformanceBenchmarkDashboard[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_PracticeBMDashboard = this.userService.getUserRights("Practice BM Dashboard");
    if (userPermissionData_IsShow_PracticeBMDashboard != null && userPermissionData_IsShow_PracticeBMDashboard != undefined && userPermissionData_IsShow_PracticeBMDashboard.length > 0) {
      this.IsShow_PracticeBMDashboard = (userPermissionData_IsShow_PracticeBMDashboard[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_IncomingBMdashboard = this.userService.getUserRights("Incoming BM dashboard");
    if (userPermissionData_IsShow_IncomingBMdashboard != null && userPermissionData_IsShow_IncomingBMdashboard != undefined && userPermissionData_IsShow_IncomingBMdashboard.length > 0) {
      this.IsShow_IncomingBMdashboard = (userPermissionData_IsShow_IncomingBMdashboard[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_OutgoinginternalBMDashboard = this.userService.getUserRights("Outgoing/internal BM Dashboard");
    if (userPermissionData_IsShow_OutgoinginternalBMDashboard != null && userPermissionData_IsShow_OutgoinginternalBMDashboard != undefined && userPermissionData_IsShow_OutgoinginternalBMDashboard.length > 0) {
      this.IsShow_OutgoinginternalBMDashboard = (userPermissionData_IsShow_OutgoinginternalBMDashboard[0].showPage == 1) ? true : false;
    }
    
    let userPermissionData_IsShow_AwarenessSession = this.userService.getUserRights("Awarness Session");
    if (userPermissionData_IsShow_AwarenessSession != null && userPermissionData_IsShow_AwarenessSession != undefined && userPermissionData_IsShow_AwarenessSession.length > 0) {
      this.IsShow_AwarenessSession = (userPermissionData_IsShow_AwarenessSession[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_AddincomingBMrequest = this.userService.getUserRights("Add incoming BM request");
    if (userPermissionData_IsShow_AddincomingBMrequest != null && userPermissionData_IsShow_AddincomingBMrequest != undefined && userPermissionData_IsShow_AddincomingBMrequest.length > 0) {
      this.IsShow_AddincomingBMrequest = (userPermissionData_IsShow_AddincomingBMrequest[0].showPage == 1) ? true : false;
    }


    let userPermissionData_IsShow_BMRequest = this.userService.getUserRights("BM Request");
    if (userPermissionData_IsShow_BMRequest != null && userPermissionData_IsShow_BMRequest != undefined && userPermissionData_IsShow_BMRequest.length > 0) {
      this.IsShow_BMRequest = (userPermissionData_IsShow_BMRequest[0].showPage == 1) ? true : false;
    }

    //let userPermissionData_IsShow_BMIncomingRequest = this.userService.getUserRights("Incoming BM Request");
    //if (userPermissionData_IsShow_BMIncomingRequest != null && userPermissionData_IsShow_BMIncomingRequest != undefined && userPermissionData_IsShow_BMIncomingRequest.length > 0) {
    //  this.IsShow_BMIncomingRequest = (userPermissionData_IsShow_BMIncomingRequest[0].showPage == 1) ? true : false;
    //}

    let userPermissionData_IsShow_BMOutgoingRequest = this.userService.getUserRights("Outgoing BM Request");
    if (userPermissionData_IsShow_BMOutgoingRequest != null && userPermissionData_IsShow_BMOutgoingRequest != undefined && userPermissionData_IsShow_BMOutgoingRequest.length > 0) {
      this.IsShow_BMOutgoingRequest = (userPermissionData_IsShow_BMOutgoingRequest[0].showPage == 1) ? true : false;
    }

    let userPermissionData_IsShow_FileManager = this.userService.getUserRights("File Manager");
    if (userPermissionData_IsShow_FileManager != null && userPermissionData_IsShow_FileManager != undefined && userPermissionData_IsShow_FileManager.length > 0) {
      this.IsShow_FileManager = (userPermissionData_IsShow_FileManager[0].showPage == 1) ? true : false;
    }



  }
  //Load Notification
  loadKPINotification() {

    let inpValue = new kpiNotification();
    
    if (this.isBMChambion || this.isBMVisitor || this.isBMTeam || this.isBMAdmin) {
      inpValue.condition = 4;
    } else { inpValue.condition = 1; }

    inpValue.tenantUno = 1;
    inpValue.notifyUno = 0;
    inpValue.userUno = this.login_UserID;
    this.KPINotification_data = [];
    this.dataTarget_notify = '';
    let elemntfyCount: any = document.getElementById("ntfyCount");
    if (elemntfyCount != null)
      elemntfyCount.style.display = "none";
    this.restApi.getKPINotification(inpValue)
      .subscribe(data => {
        
        let rtnData: any = data;
        if (rtnData.data.length > 0) {
          this.KPINotification_data = rtnData.data;

          this.nitifyCount = (this.KPINotification_data != null && this.KPINotification_data.length > 0 && this.KPINotification_data[0] != null) ? this.KPINotification_data[0].notifyCount : 0; ///this.KPINotification_data.length;
          if (this.nitifyCount > 0) {
            this.dataTarget_notify = 'dropdown2';
            if (elemntfyCount != null) {

              elemntfyCount.style.display = "inline";
              elemntfyCount.innerText = this.nitifyCount.toString();
            }


          }
        }
      },
        (error) => {

        }
      ).add(() => {

      });
  }
  // Update the notification as read
  updateKPINotification() {
    
    let inpValue = new kpiNotification();
    inpValue.condition = 3;
    inpValue.tenantUno = 1;
    inpValue.notifyUno = 0;
    inpValue.userUno = this.login_UserID;
    this.restApi.getKPINotification(inpValue)
      .subscribe(data => {
        let elemntfyCount: any = document.getElementById("ntfyCount");
        if (elemntfyCount != null) {
          elemntfyCount.innerText = '';
          elemntfyCount.style.display = "none";

        }
      },
        (error) => {

        }
      ).add(() => {

      });
  }
  //Redirct to the respective page
  submitNotifyAction(pageType: any, kpiTrnUno: any, notifyUno: any) {
    if (pageType == 'inbox') {
      if (kpiTrnUno > 0) {
        this.router.navigateByUrl('/kpiview/' + kpiTrnUno);
      }
      else {
        this.router.navigateByUrl('/inbox/dataentry');
      }

    }

  }

  logout() {
    this.shouldShow = true;
    this.userService.logout();
  }

  // window scroll top
  @HostListener('window:scroll')
  checkScroll() {
    // Both window.pageYOffset and document.documentElement.scrollTop returns the same result in all the cases. window.pageYOffset is not supported below IE 9.
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (scrollPosition >= this.topPosToStartShowing) {
      this.isScrolltoTopShow = true;
    } else {
      this.isScrolltoTopShow = false;
    }
  }

  // TODO: Cross browsing
  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
  redirectToBenchMarkMasters(type: any) {


    this.router.navigate(['/performancemaster'], { queryParams: { pfmtype: type } });

    if (type == 'surveyOption') {
      this.router.navigate(['/survey-option-master']);
    }

    if (type == 'surveyQuestion') {
      this.router.navigate(['/survey-question-master']);
    }

    if (type == 'practice') {
      this.router.navigate(['/practice-bm-progress-master']);
    }
    if (type == 'delegates') {
      this.router.navigate(['/delegates-happiness-rate-master']);
    }
    this.addorRemoveMasterClass(type);
    //document.querySelector(type).classList.add('current-page');
    return false;

  }
  addorRemoveMasterClass(type: any) {
    this.current_continent = (type == 'continent') ? true : false;
    this.current_country = (type == 'country') ? true : false;
    this.current_region = (type == 'region') ? true : false;
    this.current_sourcetype = (type == 'sourcetype') ? true : false;
    this.current_source = (type == 'source') ? true : false;
    this.current_utilitytype = (type == 'utilitytype') ? true : false;
    this.current_peertype = (type == 'peertype') ? true : false;
    this.current_peer = (type == 'peer') ? true : false;
    this.current_consideration = (type == 'consideration') ? true : false;
    this.current_position = (type == 'position') ? true : false;
    this.current_regulator = (type == 'regulator') ? true : false;
    this.current_council = (type == 'council') ? true : false;
    this.current_surveyOption = (type == 'surveyOption') ? true : false;
    this.current_surveyQuestion = (type == 'surveyQuestion') ? true : false;
    this.current_practice = (type == 'practice') ? true : false;
    this.current_objective = (type == 'strategic objective') ? true : false;
    this.current_priority = (type == 'strategic priority') ? true : false;
    this.current_delegates = (type == 'delegates') ? true : false;
  }
  redirectPracticeBMTransaction() {
    this.router.navigate(['/practice-bm-progress-transaction-list'], { queryParams: { pbmtype: 'transaction' } });
    return false;
  }

  assignDefaultFilter() {

    this.filterYear_default = 0;
    this.filterQuarter_default = 0;
    this.filterSla_default = 0;
    this.filterDivision_default = 0;
    this.filterFrequency_default = 0;

    var objFilterItem = this.utilityService.InboxFilter_get();
    if (objFilterItem != null && objFilterItem != undefined) {
      if (objFilterItem.sla != 0) {
        this.filterSla_default = objFilterItem.sla;
      }
      if (objFilterItem.year != 0) {
        this.filterYear_default = objFilterItem.year;
      }
      if (objFilterItem.quater != 0) {
        this.filterQuarter_default = objFilterItem.quater;
      }
      if (objFilterItem.division != 0) {
        this.filterDivision_default = objFilterItem.division;
      }
      if (objFilterItem.frequency != 0) {
        this.filterFrequency_default = objFilterItem.frequency;
      }

    }
  }
  loadKPIInboxCount() {


    let inpValue = new kpiInbox();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.slaUno = (this.filterSla_default > 0) ? this.filterSla_default : 0;
    inpValue.slaRuleUno = (this.filterFrequency_default > 0) ? this.filterFrequency_default : 0;
    inpValue.reportingDivisionUno = (this.filterDivision_default > 0) ? this.filterDivision_default : 0;

    inpValue.currentYear = (this.filterYear_default > 0) ? this.filterYear_default : this.currentYear;
    inpValue.currentQuarter = (this.filterQuarter_default > 0) ? this.filterQuarter_default : this.currentQuarter;
    inpValue.currentMonth = this.currentMonth;
    inpValue.currentHalf = this.currentHalf;
    inpValue.filterDataCollection = 1;//this.filterDataCollection;
    inpValue.filterOverdue = 0;//this.filterOverdue;
    inpValue.filterApproval = 0;//this.filterApproval;
    inpValue.filterCompleted = 0;//this.filterCompleted;
    inpValue.isAdmin = (this.user != null && this.user.role == 'Administrator' || this.user.role == 'SLA Admin') ? true : false;
    
    this.restApi.getKpiInboxCount(inpValue)
      .subscribe(data => {
        let rtnData: any = data;
        //this.kpiInbox_data_count = data[0];
        this.filterDataCollectionCount = rtnData.data[0].filterDataCollectionCount;
        this.filterCompletedCount = rtnData.data[0].filterCompletedCount;
        this.filterApprovalCount = rtnData.data[0].filterApprovalCount;
        this.filterOverdueCount = rtnData.data[0].filterOverdueCount;
        this.userService.refreshLeftNavCount(this.filterDataCollectionCount, this.filterApprovalCount, this.filterCompletedCount);

      },
        (error) => {
          //Called when error
          //this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
  }



  kpiperformanceredirect(strValue: string) {
    strValue = (strValue != null && strValue != '') ? strValue : "";
    this.router.navigate(["/translate-page", { returnUrl: '/slakpiperformance?pagetype=' + strValue }]);
    return false;
  }

  onClickDropDown() {
    this.loading = true;
    this.loadTenant();
    this.loadUserMaster();
  }
  onClickSwitchTenant() {
    this.loading = true;
    this.modalUserRef = this.modalService.show(
      this.SwitchTenanttemplate,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );

    setTimeout(() => {
      this.loading = false;
    }, 200);
  }


  onredirectPage(page: any) {
    this.modalUserRef.hide();
    if (page == 'inbox') {
      window.location.href = "#/inbox/dataentry";
    }
    else if (page == 'sladashboard') {
      window.location.href = "#/sladashboard/general";
    }
    else if (page == 'slaperformance') {
      window.location.href = "#/dashboard-slaperformance";
    }
    else if (page == 'digitaldashboard') {
      window.location.href = "#/dashboard-digital";
    }
    else if (page == 'moro') {
      window.location.href = "#/slakpiperformance?pagetype=Moro";
      window.location.reload();
    }
    else if (page == 'digitalx') {
      window.location.href = "#/slakpiperformance?pagetype=DigitalX";
      window.location.reload();
    }
    else if (page == 'infrax') {
      window.location.href = "#/slakpiperformance?pagetype=InfraX";
      window.location.reload();
    }
    else {
      window.location.href = "#/dashboard";
    }

    return false;
  }

  redirectPage(page: any, item: any) {

    if (item.tenantUno == this.tenantUno) {
      this.onredirectPage(page);
    }
    else {
      this.SwitchTenant(item, page);
    }
  }

  SwitchTenant(item: any, pageType: any) {
    
    var strTenant = '{"id":"' + 1 + '"}';
    localStorage.removeItem('switchTenant');
    localStorage.setItem('switchTenant', strTenant);

    this.userService.getTenantInfo(item.tenantUno, item, pageType);

    return false;
  }

  onemptyClick() { return false; }

  // Get user list
  loadUserMaster() {
    let currPage = this;
    let inpValue = new usermaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 2;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = "1";
    inpValue.ntLogin = this.user.username;
    
    this.restApiadmin.getUserMasters(inpValue)
      .subscribe(data => {
        
        if (data != null) {
          let rtnData: any = data;
          this.user_data = rtnData.data[0];

          currPage.getUserPermissionEntry(currPage.login_UserID);
        }
      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
  getUserPermissionEntry(selectedUserUno: any) {
    

    let inpValue = new userpermission();
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.userUno = selectedUserUno;
    inpValue.enteredBy = this.login_UserID;
    //inpValue.tenantUno = this.tenantUno;
    
    this.restApiadmin.getUserPermission(inpValue)
      .subscribe(data => {
        
        let rtndata: any = data;

        const mockDataset = [];
        if (this.user_data != undefined && this.user_data != null && this.user_data != '') {
          mockDataset[0] = {

            tenantUno: this.user_data.tenantUno,
            tenantName: this.getTenantName(this.user_data.tenantUno),
            divisionUno: this.user_data.divisionUno,
            divisionName: this.user_data.divisionNameEn,
            userTypeUno: this.user_data.userTypeUno,
            userTypeName: this.user_data.userTypeNameEn,
            userRoleUno: this.user_data.usergroupUno,
            userRoleName: this.user_data.usergroupEn
          };
        }
        
        for (let i = 0; i < rtndata.length; i++) {
          mockDataset[i + 1] = {
            tenantUno: rtndata[i].tenantUno,
            tenantName: rtndata[i].tenant,
            divisionUno: rtndata[i].divisionUno,
            divisionName: rtndata[i].divisionName,
            userTypeUno: rtndata[i].userTypeUno,
            userTypeName: rtndata[i].userType,
            userRoleUno: rtndata[i].userRoleUno,
            userRoleName: rtndata[i].userRole
          };
        }

        if (mockDataset.length > 0) {
          this.multiTenantList = mockDataset.sort((a, b) => a.tenantUno - b.tenantUno);
        } else {
          this.multiTenantList = [];
        }
        //this.multiTenantList = mockDataset.sort((a, b) => a.tenantUno - b.tenantUno);

        this.loading = false;
      },
        (error) => {
          //Called when error
          this.loading = false;
        }
      ).add(() => {

        //Called when operation is complete (both success and error)

      });

  }
  getTenantName(id: any) {
    var objTenant = this.tenant_data.filter(item => item.tenantUno == id);
    if (objTenant.length > 0) {
      return objTenant[0].tenantNameEn;
    } else { return ""; }

  }

  loadTenant() {

    let inpValue = new tenant();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;//this.RASHelper.encryptWithPublicKey('2');
    
    this.restApiadmin.getTenants(inpValue)
      .subscribe(data => {     
        this.tenant_data = data;
      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }

  Checkauthorized() {
    //To check unauthorized call
    var struser = localStorage.getItem('userinfo');
    if (struser) {
     let user = JSON.parse(struser);

      let objUser = new slaNote;
      objUser.userUno = user.id;
      objUser.type = user.role;
      objUser.userName = user.username;
      debugger;
      this.restApiadmin.CheckSR(objUser).subscribe(
        res => {

        },
        (err) => {

          var struser = '{"id":"' + user.id + '"}';
          localStorage.removeItem('userinfo');
          localStorage.setItem('userinfo', struser);
          this.logout();
          //}
        }
      ).add(() => {

      });
    }
  }
  
}
